import { render, staticRenderFns } from "./CoreItemOne.vue?vue&type=template&id=0ca02ec3&scoped=true&"
import script from "./CoreItemOne.vue?vue&type=script&lang=js&"
export * from "./CoreItemOne.vue?vue&type=script&lang=js&"
import style0 from "./CoreItemOne.vue?vue&type=style&index=0&id=0ca02ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca02ec3",
  null
  
)

export default component.exports